import VueSocialSharing from 'vue-social-sharing';
import Vue from 'vue';

Vue.use(VueSocialSharing);
